/** A cleaning's photo link, /clean/<token> (MTR #599). In its own file so the server and the browser read one shape. */
export const cleanTokenFromPath = (path) => {
  const m = /^\/clean\/([A-Za-z0-9_-]{43})\/?$/.exec(String(path ?? ''))
  return m ? m[1] : null
}

/* How long a photo link opens for: a cleaning is done the day it is sent, with room for a delay. */
export const PHOTO_LINK_DAYS = 3

/** A tenant's check, /move-in/<token> (MTR #599 part 3) — or /move-out/<token>, the same page for a move-out list (MTR #651). */
export const moveInTokenFromPath = (path) => {
  const m = /^\/move-(?:in|out)\/([A-Za-z0-9_-]{43})\/?$/.exec(String(path ?? ''))
  return m ? m[1] : null
}

/* The move-in check is due within 72 hours of the link (project doc 123); after that it no longer opens. */
export const MOVE_IN_DAYS = 3
